import getChargeAtPH from './getChargeAtPH';

/**
 * Use ProteinProperties.isoelectricPoint instead, this does not include residue validation.
 */
function _isoelectricPoint(aminoAcids: string): number {
  // Set pH min and pH max at extremely values just in case
  let pH1 = 0;
  let pH2 = 14;

  // Binary search on the pH that results in approximately zero charge
  let pH = (pH1 + pH2) / 2;
  let charge = getChargeAtPH(aminoAcids, pH);
  while (pH2 - pH1 > 0.0001 && Math.abs(charge) > 0.000001) {
    pH = (pH1 + pH2) / 2;
    charge = getChargeAtPH(aminoAcids, pH);
    if (charge > 0) {
      pH1 = pH;
    } else {
      pH2 = pH;
    }
  }

  return pH;
}

export default _isoelectricPoint;
